import React from "react";
import { PatientContext } from "../models/patient_context";
// import MultiSelectTextareaComponent from "./minicomponents/multi_select_textarea";
import NotesComponent from "./minicomponents/notes";
import LabelAndInputComponent from "./epilepsy/label_and_input";
// import { keyToName } from "../helpers/key_to_name";

export default class PlanComponent extends React.Component {
  static contextType = PatientContext;

  getLastAppointment = () => {
    return this.context[this.context.last_viewed];
  }

  // codeToName = (test) => {
  //   return keyToName(this.getLastAppointment(), test);
  // }

  // fetchInvestigations = () => {
  //   const investigations = this.props.tests ? this.props.tests : [];
  //   return investigations.flatMap(this.codeToName).join("\n");
  // }

  // onPrescriptionChange = (id, value) => {
  //   this.props.updateAnyObject(id, value, [this.context.last_viewed, "pharmacological"], null)
  // }

  setAppointment = (id, value) => {
    this.props.updateAnyObject(
      id, value, []
    );
  }

  onItemChange = (id, value) => {
  }

  render() {
    const appointment = this.context[this.context.last_viewed];
    const plan = appointment.plan;
    const notes = plan.notes;
    // const investigations = this.fetchInvestigations();
    // const prescriptions = appointment.pharmacological.notes;
    const next = this.context.next_appointment;
    const date = new Date(next);
    date.setHours(date.getHours() + 1);
    const iso = date.toISOString().substring(0, 16)

    return (
      <div className="emr-clerking-tab-data m-0">
        <h4 className="emr-card-headers">Plan</h4>
        <div className="emr-clerking-tab-data-items">
          {/* <MultiSelectTextareaComponent name="Investigations" id="investigations"
            value={investigations} items={[]} onItemChange={this.onItemChange}
          />
          <MultiSelectTextareaComponent name="Prescriptions" id="notes"
            value={prescriptions} items={[]} onItemChange={this.onPrescriptionChange}
          /> */}
          <LabelAndInputComponent id="next_appointment" title="Next Appointment Date"
            value={iso} type="datetime-local" onItemChange={this.setAppointment} 
          />
          <NotesComponent value={notes} id={"notes"} name="Supplementary Notes"
            onItemChange={this.props.updateAnyObject} fields={["plan"]}
          />
        </div>
      </div>
    );
  }
}